export default __webpack_public_path__ + "static/media/ashe-intro.9286f130.mp3";